import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SitemapNested } from './components/SitemapNested';
import { SitemapValueType } from './components/SitemapValueType';

function SitemapWrapperComponent({ vertical, viewer, filterType, filterTypeValue }) {
    const sharedProps = {
        vertical,
        filterType,
    };
    const sitemap = viewer?.sitemap;

    if (vertical && filterType) {
        return (
            <SitemapValueType
                sitemap={sitemap}
                filterTypeValue={filterTypeValue}
                {...sharedProps}
            />
        );
    } else {
        return <SitemapNested sitemap={sitemap} />;
    }
}
SitemapWrapperComponent.propTypes = {
    vertical: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    filterType: PropTypes.string,
    value: PropTypes.string,
    filterTypeValue: PropTypes.string,
};

export const SitemapWrapper = createFragmentContainer(SitemapWrapperComponent, {
    viewer: graphql`
        fragment SitemapWrapper_viewer on Viewer {
            sitemap(
                vertical: $vertical
                filterType: $filterType
                filterTypeValue: $filterTypeValue
                level: $level
                pageNumber: $pageNumber
            ) {
                ...SitemapNested_sitemap
                ...SitemapValueType_sitemap
            }
        }
    `,
});
